import { Component, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { RasterCatCode, RasterCategoryDto } from 'src/app/server-api/models';
import { RasterCategoryControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { IRasterCategoryFormGroup } from './IRasterCategoryFormGroup';

@Component({
  selector: 'app-raster-category',
  templateUrl: './raster-category.component.html',
  styleUrls: ['./raster-category.component.css']
})
export class RasterCategoryComponent extends DetailComponent {
  category: RasterCategoryDto;

  selectedTypeOfRaster: RasterCatCode[] = [] ;
  @Output()  preSelectedTypeOfRaster: RasterCatCode[] = [];

  constructor(
    public override translate: TranslateService,
    private rasterCategoryService: RasterCategoryControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override ngOnInit()
  {
    this.profilesAllowEdit = 'ADMIN';
    super.ngOnInit();
  }
  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.category = {} as any as RasterCategoryDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

    this.rasterCategoryService.getRasterCategory(request).subscribe((data: RasterCategoryDto) => {
      this.category = data;
      this.name = data.name;

      this.selectedTypeOfRaster[0] = this.category.code;
      this.preSelectedTypeOfRaster = this.selectedTypeOfRaster;

      this.initForm();
      this.detailForm.controls['id'].disable();
    },
    (err: string) => {
      window.alert(err.replace('Object', 'Raster category'));
    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    if (this.disableByProfile)
    {
      this.columnsVisible = new Map([
        ['id', false],
        ['name', true],
        ['code', false],
        ['code_disabled', true],
        ['colorMap', true]
      ]);
    }
    else
    {
      this.columnsVisible = new Map([
        ['id', false],
        ['name', true],
        ['code', true],
        ['code_disabled', false],
        ['colorMap', true]
      ]);
    }

    this.detailForm = this.formBuilder.group({
      id: [ '' ],
      name: [{ value: '', disabled: this.disableByProfile}, Validators.required],
      code: { value: '', disabled: this.disableByProfile },
      code_disabled: { value: '', disabled: true },
      colorMap: { value: '', disabled: this.disableByProfile },

    }) as IRasterCategoryFormGroup;

    //patch value dto to formGroup
    this.detailForm.patchValue(this.category);
    this.detailForm.controls['code_disabled'].setValue(this.category.code);
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('raster-category.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu', 'icon_next', 'icon_previous']).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
          hide: false
        },
        {
          icon: 'arrow_back',
          title: translations['icon_previous'],
          routerLink: null,
          clickMethod: 'navigatePrevious',
          hide: this.hidePrevious
        },
        {
          icon: 'arrow_forward',
          title: translations['icon_next'],
          routerLink: null,
          clickMethod: 'navigateNext',
          hide: this.hideNext
        },
        {
          icon: 'menu',
          title: translations['icon_menu'],
          routerLink: RouterLinkEnum.RASTER_CATEGORIES_LIST.toString(),
          clickMethod: 'dummy',
          hide: false
        },
      ];
    });
    this.setForm();
  }

  override saveOk() {
    super.saveOk();
    this.category = this.detailForm.value;
    this.category.code = this.selectedTypeOfRaster[0];

    var response =
      this.id !== 'new'
        ? this.rasterCategoryService.updateRasterCategory({
            id: this.id,
            body: this.category,
          })
        : this.rasterCategoryService.createRasterCategory({ body: this.category });

    response.subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        if (this.id === 'new')
        {
          this.router.navigateByUrl(RouterLinkEnum.RASTER_CATEGORIES.toString() + data.id);
        }
        else
          this.refresh();
      },
      (err) => {
        this.sidenavService.setLoading(false);
        window.alert(this.translate.instant('raster-category.update_create_failed'));
      }
    );
  }


  override delete() {
    super.delete();
    this.rasterCategoryService.deleteRasterCategory({ id: this.id }).subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        this.router.navigateByUrl(RouterLinkEnum.RASTER_CATEGORIES_LIST.toString());
      },
      (error) => {
        this.sidenavService.setLoading(false);
        window.alert(this.translate.instant('raster-category.delete_failed'));
      }
    );
  }


  setSelectedTypeOfRaster(types: RasterCatCode[])
  {
    this.selectedTypeOfRaster = types;
  }
  //https://www.javachinna.com/angular-spring-boot-crud-app/
}



